export default __webpack_public_path__ + "images/SV.6ceaa84.png";